import { Route } from 'react-router-dom';

import { Breadcrumb } from '@/components/common/Breadcrumbs/BreadcrumbsContext';
import { RouteParams, RouteToRender } from './Router';
import Layout from '@/components/Layout';

export const generateFlatRouteList = (routes: RouteParams[]) => {
  const routeElementsToRender: RouteToRender[] = [];

  const createRoute = (
    routeParams: RouteParams,
    parenRoutePath?: string,
    parentBreadcrumbs?: Breadcrumb[]
  ) => {
    const finalRoutePath = parenRoutePath
      ? (parenRoutePath + routeParams.path)
      : routeParams.path;

    const routeBreadcrumbs: Breadcrumb[] = [
      ...(parentBreadcrumbs ?? []),
      {
        path: finalRoutePath,
        title: routeParams.title,
        customBreadcrumbItem: routeParams.customBreadcrumbItem
      }
    ];

    routeElementsToRender.push({
      metadata: {
        routeBreadcrumbs
      },
      RouteComponent: (
        <Route
          {...routeParams}
          key={finalRoutePath}
          path={finalRoutePath}
        >
          <Layout>
            <routeParams.Component />
          </Layout>
        </Route>
      )
    });

    if (Array.isArray(routeParams?.children)) {
      routeParams.children.forEach((route) => {
        createRoute(route, finalRoutePath, routeBreadcrumbs);
      });
    }
  };

  routes.forEach((el) => createRoute(el));
  return routeElementsToRender;
};
